import React from 'react';

import { UseCreateTemplateFromReportModalLogic } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/CreateTemplateFromReportModal.logic';
import classes from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/CreateTemplateFromReportForm.module.scss';
import {
    DESCRIPTION_REQUIRED,
    PLACEHOLDER_TEXT,
} from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/components/Description/Description.consts';
import { CustomizedFormErrorMessage } from 'components/common';

const MAX_DESCRIPTION_CHARS = 250;
const MAX_ROWS = 4;

interface Props {
    logic: UseCreateTemplateFromReportModalLogic['logic'];
}

export const Description = ({ logic }: Props) => {
    return (
        <div className={classes.descriptionSection}>
            <div className={classes.descriptionTitle}>
                <label htmlFor={'templateDescription'}>
                    Describe the report so that your team understands how to use it:
                </label>
                <div>
                    <p>{`${logic.form.watch('templateDescription').length}/${MAX_DESCRIPTION_CHARS}`}</p>
                </div>
            </div>
            <textarea
                id={'templateDescription'}
                className={classes.descriptionTextarea}
                {...logic.form.register('templateDescription', { required: DESCRIPTION_REQUIRED })}
                rows={MAX_ROWS}
                maxLength={MAX_DESCRIPTION_CHARS}
                placeholder={PLACEHOLDER_TEXT}
            />
            {logic.form.formState.errors.templateDescription && (
                <CustomizedFormErrorMessage text={logic.form.formState.errors.templateDescription.message} />
            )}
        </div>
    );
};
